<template>
  <base-index
    ref="baseIndex"
    :columns="columns"
    :resourceName="resourceName"
    :pk="pk"
    :disabledFilterButton="false"
    :disabledAddButton="true"
    :breadcrumbs="breadcrumbs"
  >
    <template v-slot:render.status="{ item }">
      <div>
        {{ statusName(item.status) }}
      </div>
    </template>
  </base-index>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      resourceName: "requests",
      pk: "request_id",
      columns: [
        {
          value: "request_id",
          text: "依頼ID",
          filter: true,
          type: "number",
          width: 80
        },
        {
          value: "user_id",
          text: "ユーザーID",
          filter: true,
          type: "number",
          width: 80
        },
        {
          value: "user_name",
          text: "ユーザー名",
          filter: true
        },
        {
          value: "product_id",
          text: "システム管理商品ID",
          filter: true,
          type: "number",
          width: 80
        },
        {
          value: "product_name",
          text: "商品名",
          filter: true,
          width: 80
        },
        {
          value: "status",
          text: "ステータス",
          filter: true,
          type: "select",
          optionType: "common/request_status"
        },
        {
          value: "updated_at",
          text: "最終対応日時",
          filter: true,
          type: "date"
        },
        {
          value: "duplicated",
          text: "重複状態",
          filter: true,
        }
      ]
    };
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: this.isProvider ? "商品サンプル依頼一覧" : "依頼一覧",
          disabled: true
        }
      ];
    },
    isProvider() {
      return this.$store.getters[`auth/isProvider`];
    }
  }
};
</script>
